module.exports = __webpack_public_path__ + "static/media/back-mobile.41e607c5.jpg";